// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".offer.action .discount-flag{height:38px;pointer-events:none;position:absolute;right:10px;top:0;width:38px}.offer.action .discount-flag polygon{fill:#cf1619;stroke:#b81416;stroke-linejoin:round;stroke-width:1px}.offer.action .discount-flag text{fill:#fff}.offer.action .discount-flag text.digit{font-size:16px;text-anchor:end}.offer.action .discount-flag text.percent{font-size:10px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
